var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Performance Indicator Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[1.3]-Performance-Reporting---Showing-graph-hover-interaction-Copy-2",
    transform: "translate(-688.000000, -392.000000)",
    fill: "#FF5676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    transform: "translate(201.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tooltip",
    transform: "translate(378.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.000000, 32.500000)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,5 L11,11.817 L14.5734463,8.54454617 L16,9.91385685 C13.8864003,11.9426446 11.9854722,13.6067876 10.0131154,15.5 C9.50175498,15.0094966 8.61543726,14.1784956 7.6779865,13.3042416 L7.30104668,12.9529377 C7.23802472,12.8942375 7.1749674,12.8355211 7.11197066,12.7768768 L6.73548486,12.4265789 C5.30096106,11.0924835 4,9.88964698 4,9.88964698 L5.40536723,8.5 L9,11.824 L9,5 L11,5 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricDown);
export default __webpack_public_path__ + "static/media/metric-down.7b1c67b9.svg";
export { ForwardRef as ReactComponent };